module.exports = __webpack_public_path__ + "img/COEBLALA.82dba353.jpg";